/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Flex, Tooltip, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import NoteOfPresentationPreviewModal from '../../CompanySubmissionProposal/components/NoteOfPresentationPreviewModal';

const Q_GET_REQUEST = gql`
	query getLinkingNpForDoneProposal($proposalNumber: Float!) {
		getLinkingNpForDoneProposal(proposalNumber: $proposalNumber) {
			id
			type
			viewers {
				id
				createdAt
				createdBy
				userViewer {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
			}
		}
	}
`;

function ProposalDonePreview({ proposalNumber = null, ml = 4 }) {
	const modal = useDisclosure();
	const { t } = useTranslation();
	const [loadData, { data }] = useLazyQuery(Q_GET_REQUEST);

	useEffect(load, [proposalNumber]);

	function load() {
		proposalNumber && loadData({ variables: { proposalNumber } });
	}

	return (
		<>
			{data?.getLinkingNpForDoneProposal?.id && data?.getLinkingNpForDoneProposal?.viewers && (
				<>
					<Flex justifyContent="flex-start" alignItems="center" ml={ml}>
						<Tooltip label={t('Click to view')}>
							<Button
								onMouseDown={(e) => {
									e?.preventDefault();
									const width = 1024;
									const height = 720;
									const x = (screen.width - width) / 2;
									const y = (screen.height - height) / 2;
									const windowFeatures = `width=${width},height=${height},left=${x},top=${y}`;
									window?.open(
										'/#/company-submission-proposal/np/popout?id=' + data?.getLinkingNpForDoneProposal?.id + '&from=Proposal&preview=true',
										'_blank',
										windowFeatures
									);
								}}
								height="37px"
								backgroundColor="#3498db"
								size="sm"
								color="white"
								rightIcon={<FontAwesomeIcon icon={faEye} style={{ fontSize: 14, color: 'white' }} />}
							>
								{t(data?.getLinkingNpForDoneProposal?.type)}
							</Button>
						</Tooltip>
					</Flex>
					{modal?.isOpen && (
						<NoteOfPresentationPreviewModal
							id={data?.getLinkingNpForDoneProposal?.id}
							title={data?.getLinkingNpForDoneProposal?.type}
							onClose={modal?.onClose}
							isPreviewing={false}
							showBorder={true}
						/>
					)}
				</>
			)}
		</>
	);
}

export default ProposalDonePreview;
